// src/components/search/SiteResultCard.tsx

import React from 'react';
import { Card, CardContent, Typography, Chip, Stack, Box, Button } from '@mui/material';
import { Place } from '@mui/icons-material';
import { Site } from '@/types/search.types';

interface SiteResultCardProps {
  site: Site;
  onNavigate: () => void;
}

export const SiteResultCard: React.FC<SiteResultCardProps> = ({ site, onNavigate }) => (
  <Card sx={{ mb: 2, '&:hover': { boxShadow: 3 } }}>
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Place sx={{ color: 'info.main', mt: 0.5 }} />
        <Box flex={1}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            {site.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {site.address}
          </Typography>
          {site.description && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {site.description}
            </Typography>
          )}
          <Stack direction="row" spacing={1} alignItems="center">
            {site.studentCount && (
              <Chip
                label={`${site.studentCount} estudiantes`}
                size="small"
                color="info"
                variant="outlined"
              />
            )}
            <Button size="small" onClick={onNavigate} variant="outlined">
              Ver sede
            </Button>
          </Stack>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
